import React from 'react'
import {Select} from 'antd';

const {Option} = Select;

export function convertToOptions(obj, keyName, valueName, contentName,contentName2) {
    const options = [];
    if (typeof obj == 'object') {
        if (obj instanceof Array) {
            for (let o of obj) {
                options.push(<Option key={o[keyName]} value={o[valueName]}> {o[contentName]} {o[contentName2]} </Option>)
            }
        } else if (obj instanceof Object) {
            for (let key in obj) {
                if (keyName === 'name') {
                    options.push(<Option key={obj[key]} value={obj[key]}> {obj[key]} </Option>)
                } else if (keyName === 'key') {
                    options.push(<Option key={key} value={key}> {key} </Option>)
                } else {
                    options.push(<Option key={key} value={key}> {obj[key]} </Option>)
                }
            }
        }
    }
    return options;
};